import React from 'react';
import DialogForm from "../DialogForm";
import {Col, Grid} from "../Grid";
import {TYPE_GET_RAW, useFetcherSelector, useFormDataSelector, useFormSelector} from "../../redux/ReduxHelper";
import QRCode from "react-qr-code";
import T from "../../utils/T";
import {StyledCell, StyledRow, StyledTable} from "../../../styles/components/Table.styles";
import TableBody from "../TableBody";
import Link from 'styles/basic/Link';
import TextField from "../TextField";
import {FormContext} from '../FormCRUD';
import Button from "../Button";
import {daoPost} from "../../Dao";
import notification, {TYPE} from "../../utils/notification";
import {logout, userErrorHandler} from "../../utils/LoginUtils";

function InnerTOTPForm() {
    const totpKeys = useFetcherSelector({
        selector: (state) => state?.resources?.totpKeys,
        resource: 'totpKeys',
        endpoint: '/api/users/getTotp',
        type: TYPE_GET_RAW,
        cleanup: true,
    });

    const authenticatorAppAndroidLink = "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2";
    const authenticatorAppIosLink = "https://itunes.apple.com/us/app/google-authenticator/id388497605";

    if (!totpKeys) {
        return null;
    }

    return <>
        <Grid gap={5} justify={'center'}>
            <Col size={16} className='font-bold'>
                <p><T>In order to use Two Factor Authentication, please follow these steps</T>:</p>
            </Col>
            <Col size={6} align={'center'}>
                <QRCode
                    size={256}
                    value={totpKeys?.authenticatorUri}
                />
            </Col>
            <Col size={8}>
                <StyledTable>
                    <TableBody>
                        <StyledRow>
                            <StyledCell>
                                <T>Download a two-factor authenticator app like Google Authenticator for </T>
                                <Link href={authenticatorAppAndroidLink}>Android</Link>/
                                <Link href={authenticatorAppIosLink}>iOS</Link></StyledCell>
                        </StyledRow>
                        <StyledRow>
                            <StyledCell>
                                <T>Scan the QR Code or input the key below into the authentication app</T>:
                                <p>{totpKeys?.sharedKey}</p>
                            </StyledCell>
                        </StyledRow>
                        <StyledRow>
                            <StyledCell>
                                <T>After that's done, the two-factor authenticator app will provide you with
                                    an unique code.</T><br/>
                                <T>Enter the code in the confirmation box below</T>:
                            </StyledCell>
                        </StyledRow>
                    </TableBody>
                </StyledTable>
            </Col>
            <Col/>
        </Grid>
        <TextField
            label='Verification Code'
            field='code'
            required
        />
    </>;
}

export default function EnableTOTPFormDialog(props) {
    return (
        <DialogForm
            width='1/2'
            title='Enable Two Factor Authentication'
            method='POST'
            {...props}
        >
            <InnerTOTPForm/>
        </DialogForm>
    );
}

export function EnableTOTPForm() {
    const context = useFormSelector({
        resource: 'enableTOTPForm'
    });

    const data = useFormDataSelector(context);

    const handleSubmit = async e => {
        e.preventDefault();

        try {
            const ret = await daoPost('/api/users/enableTotp', data);
            notification({ type: TYPE.SUCCESS, message: ret?.message });
            logout();
        } catch (e) {
            userErrorHandler(e, context)
        }
    }

    const backToLoginPage = () => {
        logout();
    }


    return (
        <FormContext.Provider value={context}>
            <InnerTOTPForm/>
            <Button color='primary' type='button' onClick={handleSubmit}>Save</Button>
            <Button color='secondary' type='button' onClick={backToLoginPage}>Cancel</Button>
        </FormContext.Provider>
    );
}